<div class="header-container">
  <label class="header-text">MEDIA UPLOADS REPORT</label>
  <back-to-scheduler></back-to-scheduler>
</div>
<div class="table-header">
  <input
    class="search-input"
    type="text"
    placeholder="Search"
    [(ngModel)]="searchQuery"
    (keyup)="onkeyup($event)"
    (blur)="search()"
    maxlength="50"
  />
  <div class="last-refresh">{{ lastRefresh && formatLastRefresh() }}</div>
  <div
    class="refresh"
    inlineSVG="/assets/icons/refresh.svg"
    (click)="refresh()"
  ></div>
</div>
<ngx-datatable
  class="bootstrap horiz-border gray-bg"
  [rows]="rows"
  [rowHeight]="50"
  [count]="total"
  [limit]="30"
  [columnMode]="'force'"
  [scrollbarV]="true"
  [externalPaging]="true"
  [externalSorting]="true"
  [sorts]="sorts"
  (sort)="onSort($event)"
  (page)="onPage($event)"
  [loadingIndicator]="isLoading"
  [footerHeight]="50"
  [headerHeight]="45"
>
  <ngx-datatable-column
    prop="filename"
    name="File Name"
    [width]="400"
  ></ngx-datatable-column>
  <ngx-datatable-column prop="tenantUniqueId" name="Video ID" [width]="400">
    <ng-template let-value="value" ngx-datatable-cell-template>
      {{ value }}
      <evrideo-copy-button
        *ngIf="value && value.length > 0"
        [copy-clipboard]="value"
        (copied)="showToastr()"
        title="Copy VIDEO ID"
      ></evrideo-copy-button>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="date" name="Date and Time">
    <ng-template let-value="value" ngx-datatable-cell-template>
      {{ formatDate(value) }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="status" name="Upload Status" [sortable]="false">
    <ng-template let-value="value" ngx-datatable-cell-template>
      <div class="status-cell" [title]="formatStatus(value)">
        <i [inlineSVG]="getStatusIcon(value)"></i>
        <div>{{ formatStatus(value) }}</div>
      </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    *ngIf="allowedQCAnalyze"
    prop="quality"
    name="Quality"
    [width]="200"
    [sortable]="false"
  >
    <ng-template let-value="value" ngx-datatable-cell-template>
      <div
        *ngIf="value > 0"
        [class]="'quality quality-' + formatQuality(value)"
      >
        {{ formatQuality(value) | uppercase }}
      </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    *ngIf="allowedQCAnalyze"
    prop="mediaId"
    name=""
    [sortable]="false"
    [width]="200"
  >
    <ng-template let-value="value" ngx-datatable-cell-template>
      <div
        class="view-qc-button show-on-row-hover"
        *ngIf="showQcButton(value)"
        (click)="gotoQc(value)"
      >
        View QC
      </div>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column prop="mediaId" name="Actions">
    <ng-template let-row="row" ngx-datatable-cell-template>
      <a
        *ngIf="row.status === 'success'"
        [routerLink]="'/mam/editMedia/' + row.mediaId"
      >
        Edit Media</a
      >
    </ng-template>
  </ngx-datatable-column>
</ngx-datatable>
